import BcomSearchForm from '@resources/js/components/BcomSearchForm'

if (document.querySelector('#search-form')) new BcomSearchForm('#search-form')
